import React, { Component } from "react";
import { DepositOverview } from "./deposit-overview";
import { toast } from "react-toastify";
import "../../shared/reporting-section.css";
import "./style.css";

const initialState = {
  report: {
    user: {},
    mutual_ips: [],
    mutual_payment_accounts: [],
    mutual_tax_ids: [],
    real_chart_of_accounts: [],
    kyc_verification_statuses: {
      id: {
        requested: false,
        status: null,
      },
      address: {
        requested: false,
        status: null,
      },
      payment_accounts: [],
    },
    pep_sip_check: {},
    has_card_deposit: false,
    has_transferred_bonus: false,
    tax_ids: [],
    bonus_into_real_transactions: [],
    automated: {},
    comment: ""
  },
  actionLoading: false,
  isLoading: false,
  commentLoading: false,
  commentMessage: null, // { type: 'success'|'error', text: 'mensaje' }
};

export default class DepositDetail extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  componentDidMount() {
    this.fetchDeposit();
  }

  fetchDeposit() {
    window.api
      .get(`/admin/payments/deposits/${this.getId()}/basic`)
      .then((report) =>
        this.setState({ report: { ...this.state.report, ...report } })
      );
    window.api
      .get(`/admin/payments/deposits/${this.getId()}/financials`)
      .then((report) =>
        this.setState({ report: { ...this.state.report, ...report } })
      );
    window.api
      .get(`/admin/payments/deposits/${this.getId()}/antifraud`)
      .then((report) =>
        this.setState({ report: { ...this.state.report, ...report } })
      );
  }

  getId() {
    return this.props.match.params.id;
  }

  async edit(data, password) {
    try {
      this.setState({ actionLoading: true });
      await window.api({
        method: "put",
        url: `/admin/payments/deposits/${this.getId()}`,
        data: data,
        headers: {
          "x-admin-password": password,
        },
      });
      await this.fetchDeposit();
    } catch (err) {
      toast.error(err.message);
    }

    this.setState({ actionLoading: false });
  }

  async saveComment(comment) {
    if (!comment || comment.trim().length === 0) {
      this.setState({
        commentMessage: { type: 'error', text: 'Comment cannot be empty' }
      });
      return;
    }

    try {
      this.setState({
        commentLoading: true,
        commentMessage: null
      });

      await window.api({
        method: "put",
        url: `/admin/payments/deposits/${this.getId()}/comment`,
        data: { comment: comment.trim() }
      });

      this.setState({
        report: {
          ...this.state.report,
          comment: comment.trim()
        },
        commentMessage: {
          type: 'success',
          text: 'Comment saved successfully'
        }
      });

    } catch (err) {
      this.setState({
        commentMessage: {
          type: 'error',
          text: err.message || 'Failed to save comment'
        }
      });
    }

    this.setState({ commentLoading: false });

    setTimeout(() => {
      this.setState({ commentMessage: null });
    }, 3000);
  }

  render() {
    const deposit = this.state.report;
    const loading = this.state.actionLoading;

    return (
      <div className="deposit-page">
        {this.state.isLoading && (
          <div className="loading-overlay">
            <h2>Loading, please wait ...</h2>
            <div className="loader" />
          </div>
        )}

        <DepositOverview
          deposit={deposit}
          loading={loading}
          fetchDeposit={this.fetchDeposit.bind(this)}
          edit={this.edit.bind(this)}
          comment={deposit.comment || ''}
          commentLoading={this.state.commentLoading}
          commentMessage={this.state.commentMessage}
          saveComment={this.saveComment.bind(this)}
        />
      </div>
    );
  }
}